import React, { useState } from 'react'
import { PlusCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { Button, Col, Image, Row, Space, Spin, Upload, notification } from 'antd'
import PropTypes from 'prop-types'
import { fetchPresignedUrl, uploadFileToS3WithPresignedUrl } from '~actions'
import { PhotoSettings } from '~components'
import styles from './ImageUploader.module.css'

const { Dragger } = Upload

const ImageUploader = ({
  handleIconChange,
  handleUpload,
  pageType,
  logoUrl,
  alt
}) => {
  const [uploadStatus, setUploadStatus] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [fileLists, setFileLists] = useState([])

  const fileToS3 = async (file) => {
    if (fileLists.length > 1) {
      notification.warning({ message: 'You can only upload one file!' })
      return
    }
    const isImage = file.type.startsWith('image/')
    const isSVG = file.type === 'image/svg+xml'
    if (!isImage && !isSVG) {
      notification.warning({ message: 'You can only upload image files (JPG, PNG, JPEG, SVG)' })
    }
    try {
      setUploadStatus(true)
      const fileName = file?.name.split('.')
      const formattedFile = `${fileName[0]}_${new Date().getTime()}.${fileName[1]}`
      const response = await fetchPresignedUrl({
        fileName: `event-engine/${formattedFile}`,
        fileType: file.type
      })
      const { presignedPutUrl, url } = response
      await uploadFileToS3WithPresignedUrl(presignedPutUrl, file)
      setUploadStatus(false)
      setFileLists([file])
      return url
    } catch (error) {
      console.error(error)
      setUploadStatus(false)
    }
  }
  const handleChange = async ({ file }) => {
    const url = await fileToS3(file)
    handleUpload(url)
  }

  const uploadFileToS3 = async ({ file, onSuccess, onError }) => {
    const url = await fileToS3(file)
    handleUpload(url)
  }

  const handleDeleteClick = (event) => {
    setFileLists([])
    handleUpload('')
    event.preventDefault()
  }

  return (<Space className={styles.mainContainer} direction='vertical' size={12}>{uploadStatus && <Spin indicator={<LoadingOutlined spin />} size="large" />}
    { logoUrl &&
      <Row>
        <Space style={{ justifyContent: 'space-between', gap: 16, display: 'flex', alignItems: 'flex-end' }}>
          <Col>
            <Image
              src={logoUrl}
              style={{ maxHeight: 'unset', height: 'auto' }}
            />
          </Col>
          {/* <Space style={{ position: 'absolute', top: '20px', left: '220px' }}>{fileLists.length > 0 &&
            <div style={{ display: 'flex', flexDirection: 'column' }}><div><Typography.Title level={3}>{fileLists[0]?.name}</Typography.Title></div>
              {alt && <div><Typography.Title level={3}>{alt}</Typography.Title></div>}</div>}</Space> */}
          <Space className={styles.container}>
            <Upload accept='image/*' customRequest={uploadFileToS3} maxCount={1} showUploadList={false}>
              <Button style={{ background: '#0078D4', borderColor: '#0078D4', fontSize: 14 }} type="primary">Replace</Button>
            </Upload>
            {pageType !== 'tours' && <Button onClick={() => setIsOpen(true)} type="primary">Edit Image</Button>}
            <Button className="cloudinary-delete" onClick={handleDeleteClick} style={{ background: '#DA0D50', borderColor: '#DA0D50', fontSize: 14 }} type="primary">Delete</Button>
          </Space>
        </Space>
        {isOpen && <PhotoSettings alt={alt} handleIconChange={handleIconChange} isOpen={isOpen} logoUrl={logoUrl} setIsOpen={setIsOpen} />}
      </Row>
    }
    {!logoUrl && <Dragger
      accept='image/*,image/svg+xml'
      beforeUpload={() => false}
      fileList={fileLists}
      maxCount={1}
      onChange={handleChange}
      onRemove={() => setFileLists([])}
    >
      <Row align={'middle'} gutter={[20, 20]} justify={'center'}>
        <div className={ styles['add-icon'] } style={ { display: 'flex', padding: '10px 16px', height: '144px', width: '285px', justifyContent: 'center', alignItems: 'center' } }>
          <PlusCircleOutlined style={{ fontSize: '40px', color: '#555555' }} />
        </div>
      </Row>
    </Dragger>}
  </Space>
  )
}

ImageUploader.propTypes = {
  alt: PropTypes.string,
  handleIconChange: PropTypes.func,
  handleUpload: PropTypes.func,
  logoUrl: PropTypes.string,
  pageType: PropTypes.string
}

export default ImageUploader
